export enum FieldsEnum {
  firstName = 'firstName',
  lastName = 'lastName',
}

export type IParamsRegisterGtmAnswersStep4 = {
  phone: string | null
}
